import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectClothIsInfo } from '../../Selectors/Master/ItemSelectors';
import { Grid, Paper } from '@mui/material';
import { fetchClothIssueInfo } from '../../../Store/PHPSlice/Cutting/clothIssue';

const ClothIssueView = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        dt: '',
        empNm: '',
        ordType: '',
        soId: '',
        sono: '',
        totMtr: '',
        challanId: ''
    });
    const dispatch = useDispatch();
    const clIssInfo = useSelector(selectClothIsInfo);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchClothIssueInfo(Id))
    }, [Id, dispatch]);


    useEffect(() => {
        if (clIssInfo?.data) {
            const item = clIssInfo?.data;
            setFormData(prev => ({
                ...prev,
                dt: item?.dt,
                empNm: item?.empNm,
                ordType: item?.ordType,
                soId: item?.soId,
                sono: item?.sono,
                totMtr: item?.totMtr,
                challanId: item?.challanId
            }));
        }
    }, [clIssInfo]);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const handleViewClick = (id) => {
        window.open(`/ClothIssueLumpsView/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Cloth Issue Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>

                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>
                                    <td>:</td>
                                    <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Order Type</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.ordType}</td>
                                    <td style={{ width: '200px' }}>Challan No.</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.challanId}</td>
                                </tr>

                                {formData.soId != '0' &&
                                    <tr>
                                        <td style={{ width: '200px' }}>SO No.</td>
                                        <td>:</td>
                                        <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.sono}</td>

                                    </tr>}

                                <tr>
                                    <td style={{ width: '200px' }}>Total Mtr.</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.totMtr}</td>
                                    {/* <td style={{ width: '200px' }}>Challan No.</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.challanId}</td> */}
                                </tr>
                            </tbody>

                        </table>
                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Item</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Bale</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Lump</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Mtr.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Mtr.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(clIssInfo?.data?.item) && clIssInfo?.data?.item?.length > 0 ? clIssInfo?.data?.item?.map((item, index) => (
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.itemNm}</TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                {item?.info?.length > 0 ? item?.info?.map((inf, infIndex) => (
                                                    <div key={infIndex}>
                                                        {infIndex > 0 && <hr />}
                                                        {inf.clothNm}
                                                    </div>
                                                )) : null}
                                            </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                {item?.info?.length > 0 ? item?.info?.map((inf, infIndex) => (
                                                    <div key={infIndex}>
                                                        {infIndex > 0 && <hr />}
                                                        {inf.baleNo}
                                                    </div>
                                                )) : null}
                                            </TableCell>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                {item?.info?.length > 0 ? item?.info?.map((inf, infIndex) => (
                                                    <div key={infIndex}>
                                                        {infIndex > 0 && <hr />}
                                                        <button type='button' style={{ fontSize: '10px' }} className='add' onClick={()=>handleViewClick(inf.baleId)}>info</button>
                                                    </div>
                                                )) : null}
                                            </TableCell>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                {item?.info?.length > 0 ? item?.info?.map((inf, infIndex) => (
                                                    <div key={infIndex}>
                                                        {infIndex > 0 && <hr />}
                                                        {inf.gMtr}
                                                    </div>
                                                )) : null}
                                            </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.totmtr}</TableCell>
                                        </TableRow>
                                    )) : null}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>

                </Paper>
            </Grid>
        </>
    );
};

export default ClothIssueView;
